import { string, object } from 'yup'

export const backgroundSchema = object({
  big: string().required(),
  medium: string().required(),
  small: string().required(),
})
